module.exports = __webpack_public_path__ + "static/media/chevron-right.fa19fd03.svg";